import windowService from "./window-service";
import {
  EventActions,
  LOGGED_OUT_USER_STATUS,
  VERSION,
} from "../utility/constants";
import { GlobalDataLayerService } from "./analytics/global-data-layer-service";
import { PHN_AUTH_EVENT, dispatchAuthEvent } from "./auth-event.service";

// Avoid turning this function into a promise
export function onComponentDidLoad(): void {

  // This slight delay is necessary so that consumers can listen to the event early enough
  setTimeout(() => {
    dispatchAuthEvent({
      eventType: PHN_AUTH_EVENT.INIT,
      state: LOGGED_OUT_USER_STATUS,
    });
  });

  windowService.version = VERSION;
  GlobalDataLayerService.getInstance().pushDataLayerEvent(
    EventActions.GENERAL_LOAD,
  );
}
